import React from "react";
import StandAloneCourses from "../components/pages/Dashboard/StandAloneCourses";
import SideNav from "../components/SideNav/sideNav";
import Header from "../components/Header/hearder";
import { Wrapper } from "./layout.styles";

const StandAloneCoursesLayout = () => {
  return (
    <React.Fragment>
      <Header />
      <Wrapper>
        <SideNav />
        <div style={{margin: "70px 0px 0px 200px", width: "100%"}}>
        <StandAloneCourses />
        </div>
      </Wrapper>
    </React.Fragment>
  );
};

export default StandAloneCoursesLayout;